import {createSelector} from "reselect/es"; // fix for Webstorm IDE code analysis
import * as R from 'ramda';
import {codeTables} from "../../codes";
import moment from "moment";

export const compArr = (a, b) => {
  if (a.length !== b.length) return false;
  for (let i = a.length; i--;) if (a[i] !== b[i]) return false;
  return true;
};

export const projectViewSelector = createSelector(
  state => state.view.data,
  state => state.companies.data,
  (projects, companies) => Object.values(projects).map(project => ({
    ...project,
    resource: {
      ...project.resource,
      company: companies[(project.resource || {}).ownercompanyid]
    }
  }))
);

export const projectCalendarSelector = createSelector(
  state => state.reports.calendar.projects,
  (projectcalendar) => {
    if (!projectcalendar || !projectcalendar.resource) return [];
    projectcalendar = R.map(R.pipe(
      (value) => ({ ...value, date: moment(value.date) })
    ), projectcalendar.resource);
    return projectcalendar;
  }
);

export const projectStatusSelector = createSelector(
  state => state.reports.by_status.projects,
  (projectstatus) => {
    if (!projectstatus || !projectstatus.resource) return [];
    projectstatus = R.map(
      ({ status, count }) => ({
        key: codeTables.get('projectstatus').find(code => code.code === status),
        value: count
      }),
      projectstatus.resource
    );
    return projectstatus;
  }
);

export const subdocumentStatusReportSelector = createSelector(
  (state, props) => state.reports.by_status[props.path],
  (state, props) => codeTables.get(props.code),
  (state, props) => codeTables.get('colors'),
  (status, codeTable, colors) => {
    if (!status || !status.resource) return [];
    status = R.map(
      ({ status, count }) => {
        const code = codeTable.find(code => code.code === status);
        if (code.color) {
          const colorCode = colors.find(record => record.code === code.color);
          if (colorCode) code.color = colorCode.name;
        }
        return ({
          key: code,
          value: count
        });
      },
      status.resource
    );
    return status;
  }
);

export const subViewSelector = createSelector(
  state => state.view.subview,
  (subdocuments) => {
    if (!Object.values(subdocuments.data).length) return null;
    return Object.values(subdocuments.data);
  }
);



// WEBPACK FOOTER //
// ./src/components/Projects/selectors.js